import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: "app-setting-manage-address",
  templateUrl: "./setting-manage-address.component.html",
  standalone:false,
  styleUrls: ["./setting-manage-address.component.scss"],
})
export class SettingManageAddressComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  constructor(
    private location: Location,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.toastr.success(
      "You have successfully updated your address",
      "Address updated"
    );
    // this.toastr.success(
    //   "You have successfully removed your address",
    //   "Address removed"
    // );
  }

  async ngOnInit(): Promise<void> {}

  settingEditPrimary() {
    this.router.navigateByUrl("/SettingEditPrimary");
  }
  showModal(num) {
    this.modalObservable.next(num);
  }
  back() {
    this.location.back();
  }
}

